var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "package-container" }, [
    _vm.isShowPromotionTag
      ? _c("div", { staticClass: "top-promotion" }, [
          _c("div", { staticClass: "left-promotion flex a-i-c" }, [
            _vm.itemData.promotion && _vm.itemData.promotion.title
              ? _c(
                  "div",
                  { staticClass: "promotion-tag flex-center t-c origin" },
                  [_vm._v("特價")]
                )
              : _vm.itemData.type == 0
              ? _c(
                  "div",
                  { staticClass: "promotion-tag flex-center t-c blue" },
                  [_vm._v("普通商品")]
                )
              : _vm.itemData.type == 1
              ? _c(
                  "div",
                  { staticClass: "promotion-tag flex-center t-c red" },
                  [_vm._v("包裹")]
                )
              : _vm._e(),
            _vm.itemData.promotion
              ? _c("span", [
                  _vm._v(" " + _vm._s(_vm.itemData.promotion.title) + " "),
                ])
              : _vm._e(),
          ]),
          _c("div", { staticClass: "right-addbuy" }),
        ])
      : _vm._e(),
    _c("div", { staticClass: "goods-wrap" }, [
      _vm.itemData.spuCover
        ? _c("div", { staticClass: "goods-cover" }, [
            _c("img", {
              staticClass: "order-detail-cover",
              attrs: {
                lazyLoad: true,
                mode: "aspectFit",
                type: "custom",
                src: _vm.itemData.spuCover,
              },
            }),
          ])
        : _vm._e(),
      _c(
        "div",
        { staticClass: "sku-info pt-5", staticStyle: { "min-height": "40px" } },
        [
          _vm.itemData.type == 1
            ? _c("div", { staticClass: "pack-content" }, [
                _c("div", { staticClass: "spu-title flex a-i-c" }, [
                  _c("div", { staticClass: "strong flex a-i-c" }, [
                    _c("div", [
                      _vm.itemData.extraJson &&
                      _vm.getEcPackName(_vm.itemData.extraJson)
                        ? _c("span", [
                            _vm._v(
                              _vm._s(_vm.getEcPackName(_vm.itemData.extraJson))
                            ),
                          ])
                        : _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.itemData.spuName ? _vm.itemData.spuName : ""
                              )
                            ),
                          ]),
                    ]),
                  ]),
                  _c("div", [
                    _vm._v(
                      "NT$ " +
                        _vm._s(
                          _vm.itemData.unitPrice ? _vm.itemData.unitPrice : 0
                        )
                    ),
                  ]),
                ]),
                _vm.manageCode
                  ? _c("div", { staticClass: "sku-item" }, [
                      _vm._v(" " + _vm._s(_vm.manageCode) + " "),
                    ])
                  : _vm._e(),
                _c("div", { staticClass: "spu-count-refund" }, [
                  _c("div", { staticClass: "quantity-content" }, [
                    _c("div", { staticClass: "count" }, [
                      _vm._v(
                        "x " +
                          _vm._s(
                            _vm.itemData.quantity ? _vm.itemData.quantity : 0
                          )
                      ),
                    ]),
                  ]),
                ]),
              ])
            : _c("div", { staticClass: "spu-content" }, [
                _c("div", { staticClass: "spu-title" }, [
                  _c("span", { staticClass: "strong" }, [
                    _vm._v(
                      _vm._s(_vm.itemData.spuName ? _vm.itemData.spuName : "")
                    ),
                  ]),
                  _c("span", { staticClass: "spu-title-price" }, [
                    _vm._v(
                      "NT$ " +
                        _vm._s(
                          _vm.itemData.unitPrice ? _vm.itemData.unitPrice : ""
                        )
                    ),
                  ]),
                ]),
                _c("div", { staticClass: "sku-item justify-between" }, [
                  _c("span", { staticClass: "strong" }, [
                    _vm._v(
                      _vm._s(
                        _vm.itemData.propertyValues
                          ? _vm.itemData.propertyValues
                          : ""
                      )
                    ),
                  ]),
                ]),
                _c("div", { staticClass: "spu-count-refund" }, [
                  _c("div", { staticClass: "quantity-content" }, [
                    _c("div", { staticClass: "count" }, [
                      _vm._v(
                        "x " +
                          _vm._s(
                            _vm.itemData.quantity ? _vm.itemData.quantity : ""
                          )
                      ),
                    ]),
                  ]),
                ]),
              ]),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }